import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  card: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.new.spacing.medium,
    padding: '0.75rem',
    backgroundColor: theme.new.color.common.white,
    border: `1px solid ${theme.new.color.line.hairline}`,
    borderRadius: theme.new.shape.borderRadius.medium,
  },
  titleRow: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    gap: theme.new.spacing.xsmall,
  },
  title: {
    flex: '1 1 0',
    minWidth: 0,
    color: theme.new.color.textPrimary,
    margin: 0,
  },
  body: {
    color: theme.new.color.textSecondary,
    margin: 0,
    width: '100%',
  },
  closeButton: {
    width: 16,
    height: 16,
    padding: 0,
    flexShrink: 0,
    color: theme.new.color.textPrimary,
    borderRadius: 0,
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  actionsRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: theme.new.spacing.small,
  },
}));

export default useStyles;
